<template lang='pug'>
  v-card.overflow-y-auto(color='primary' dark height='100%')
    v-card-title Documentos
    v-card-text
      v-data-table.primary(
        :headers="encabezado"
        :items="Registro"
        hide-default-footer
      )
        template( v-slot:item.numero='{item}')
          span {{item.nombre_de_comprobante}} {{item.serie}}-{{String(item.numero).padStart(4, 0)}} 
        template( v-slot:item.aceptada_por_sunat='{item}')
          v-btn(icon target='_blank' :href='item.enlace_del_pdf')
            v-icon( small ) fa-download
          v-btn(icon )
            v-icon( small ) {{ item.aceptada_por_sunat ? "fa-check" : "fa-times" }}

        

</template>
<script>
import { mapState, mapActions, mapGetters } from 'vuex';
export default {
  data: ()=> ({
    encabezado: [
      { text: 'Documento', value: 'numero' },
      { text: '', value: 'aceptada_por_sunat' },
    ]
  }),
  methods:{
    ...mapActions({
      Obtener_todo: 'Documentos/obtener_todo'
    })
  },
  created(){
    if(this.db_activada) this.Obtener_todo()
  },
  watch:{
    'db_activada'(){
      this.Obtener_todo()
    }
  },
  computed:{
    ...mapState({
      db_activada: state => state.Customers.db_activada
    }),
    ...mapGetters({
      Registro: 'Documentos/imprimir'
    })
  }
}
</script>